/** Ported from Anvil src/lib/screen-svg.ts. SVG regen stays renderer-side
 *  (TDD §8.3): write both .json + .svg via design:writeScreen. */
import type { Screen, Zone } from '@volley/crucible-ipc-types';
import { SURFACE_DIMENSIONS, colorFor, labelFor } from './zone-kinds';

function escapeXml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

function rectFor(zone: Zone): string {
  const color = colorFor(zone.kind);
  const fontSize = Math.max(14, Math.min(zone.width, zone.height) * 0.06);
  const labelText = zone.label || labelFor(zone.kind) || '—';
  const subText = zone.kind && zone.kind !== 'other' ? labelFor(zone.kind) : '';
  return `
    <g>
      <rect x="${zone.x}" y="${zone.y}" width="${zone.width}" height="${zone.height}"
        fill="${color}" fill-opacity="0.18"
        stroke="${color}" stroke-width="2"
        rx="6" ry="6"/>
      <text x="${zone.x + 12}" y="${zone.y + 24}"
        fill="${color}" font-family="-apple-system, system-ui, sans-serif"
        font-size="${fontSize}" font-weight="600">${escapeXml(labelText)}</text>
      ${
        subText
          ? `<text x="${zone.x + 12}" y="${zone.y + 24 + fontSize + 4}"
            fill="${color}" fill-opacity="0.65"
            font-family="-apple-system, system-ui, sans-serif"
            font-size="${fontSize * 0.75}">${escapeXml(subText)}</text>`
          : ''
      }
    </g>`;
}

export function renderScreenSvg(screen: Screen): string {
  const dims = SURFACE_DIMENSIONS[screen.surface];
  // Render in stacking order so the .svg matches the canvas (higher z on top).
  const zones = [...screen.zones]
    .sort((a, b) => (a.zIndex ?? 0) - (b.zIndex ?? 0))
    .map(rectFor)
    .join('\n');
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${dims.width} ${dims.height}" width="${dims.width}" height="${dims.height}">
  <title>${escapeXml(screen.name)} (${screen.surface.toUpperCase()})</title>
  <rect x="0" y="0" width="${dims.width}" height="${dims.height}" fill="#16161a"/>
  <rect x="2" y="2" width="${dims.width - 4}" height="${dims.height - 4}"
    fill="none" stroke="#2a2a32" stroke-width="2" rx="12" ry="12"/>
  ${zones}
</svg>
`;
}
